var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBitBucketIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.08498 0.234131C1.07963 0.234131 1.07429 0.234131 1.06895 0.234131C0.481025 0.234131 0 0.71439 0 1.30137C0 1.36007 0.00534473 1.41343 0.0160342 1.47213L4.55371 28.975C4.67129 29.6687 5.27524 30.181 5.9754 30.1863H27.7445C28.2736 30.1916 28.7279 29.8074 28.8134 29.2898L33.3511 1.47747C33.3618 1.41877 33.3671 1.36541 33.3671 1.30671C33.3671 0.719727 32.8861 0.239467 32.2982 0.239467C32.2928 0.239467 32.2875 0.239467 32.2821 0.239467L1.08498 0.234131ZM20.1924 20.1115H13.2442L11.3629 10.2982H21.876L20.1924 20.1115Z",
    fill: "#2684FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.908 10.2981H21.8759L20.1923 20.1114H13.2442L5.04004 29.834C5.30193 30.0581 5.6333 30.1808 5.97537 30.1862H27.7498C28.2789 30.1915 28.7332 29.8073 28.8187 29.2897L31.908 10.2981Z",
    fill: "url(#paint0_linear_3167_1197)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3167_1197",
    x1: 34.2338,
    y1: 13.0584,
    x2: 15.563,
    y2: 27.6535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitBucketIcon);
export default __webpack_public_path__ + "static/media/bitBucket-icon.efa99cfdccc7ece2e584ad3c05dacdcb.svg";
export { ForwardRef as ReactComponent };